<div class="header">
  <h3>Admin</h3>
</div>
<div class="row">
  <div class="col tab-menu">
    <admin-nav-menu [currentTab]="'questions'"></admin-nav-menu>
  </div>

  <div class="col col-constrained">
    <fieldset>
      <legend>Questions</legend>

      <div class="d-flex justify-content-between align-items-center mb-2">
        <div>
          <div ngbDropdown autoClose="outside" class="d-inline-block mr-2" [placement]="['bottom-left', 'bottom-right', 'top-left', 'top-right']" (openChange)="onFilterOpen($event)" #filterDropdown="ngbDropdown">
            <button type="button" class="btn btn-sm btn-secondary" id="inspection-question-filter-toggle" ngbDropdownToggle>
              <i class="fa fa-filter"></i>
              Filter
            </button>
            <div ngbDropdownMenu aria-labelledby="inspection-question-filter-toggle" class="p-3">
              <div class="mb-2">
                <label for="inspection-question-code-filter" class="form-label mb-1">Question Code</label>
                <input type="text" class="form-control form-control-sm" id="inspection-question-code-filter" [(ngModel)]="draftQuestionCodeFilter" />
              </div>
              <div class="mb-3">
                <label for="inspection-question-text-filter" class="form-label mb-1">Question</label>
                <input type="text" class="form-control form-control-sm" id="inspection-question-text-filter" [(ngModel)]="draftQuestionTextFilter" />
              </div>
              <div class="mb-2">
                <label for="inspection-question-modified-by-filter" class="form-label mb-1">Last Modified By</label>
                <input type="text" class="form-control form-control-sm" id="inspection-question-modified-by-filter" [(ngModel)]="draftLastModifiedByFilter" />
              </div>
              <div class="row mb-2">
                <div class="col">
                  <label for="inspection-question-modified-from-filter" class="form-label mb-1">Last Modified From</label>
                  <input type="date" class="form-control form-control-sm" id="inspection-question-modified-from-filter" [(ngModel)]="draftLastModifiedFromFilter" />
                </div>
                <div class="col">
                  <label for="inspection-question-modified-to-filter" class="form-label mb-1">Last Modified To</label>
                  <input type="date" class="form-control form-control-sm" id="inspection-question-modified-to-filter" [(ngModel)]="draftLastModifiedToFilter" />
                </div>
              </div>
              @if (lastModifiedDateFilterError) {
                <div class="text-danger small mb-2">{{lastModifiedDateFilterError}}</div>
              }
              <div class="form-check mb-3">
                <input type="checkbox" class="form-check-input" id="inspection-question-active-filter" [(ngModel)]="draftActiveFilter" />
                <label for="inspection-question-active-filter" class="form-check-label">Active only</label>
              </div>
              <button type="button" class="btn btn-sm btn-primary" (click)="applyFilters(filterDropdown)">Apply</button>
            </div>
          </div>
          <button type="button" class="btn btn-sm btn-secondary" (click)="clearFilters()">
            <i class="fa fa-times"></i>
            Clear All
          </button>
        </div>
        <a [routerLink]="['../question']" [queryParams]="{ id: 'new' }" class="btn btn-sm btn-primary text-nowrap">
          <i class="fa fa-plus"></i>
          New Question
        </a>
      </div>

      <grid-pager [actionName]="'/admin/questions'" [page]="page" [limit]="limit" [pageCount]="pageCount" [limits]="pageLimitOptions"></grid-pager>

      <div class="table-responsive">
        <table id="inspection-questions-grid" class="table table-striped table-align-middle my-2">
          <thead>
            <tr class="headers-row">
              <th>Question Code</th>
              <th>Question</th>
              <th>Last Modified Date</th>
              <th>Last Modified By</th>
              <th>Active</th>
            </tr>
          </thead>
          <tbody>
            @if (questions.length === 0) {
              <tr>
                <td colspan="5">
                  <span class="d-block p-2 text-center">
                    <i class="fa fa-ban text-danger"></i>
                    No data to display&hellip;
                  </span>
                </td>
              </tr>
            }
            @for (question of questions; track question.id) {
              <tr (click)="editQuestion(question)" [style.cursor]="isToggling ? 'default' : 'pointer'">
                <td>{{question.questionCode}}</td>
                <td>{{getDisplayText(question)}}</td>
                <td>{{getLastModifiedDate(question) | date : 'shortDate'}}</td>
                <td>{{getLastModifiedBy(question)}}</td>
                <td (click)="$event.stopPropagation()">
                  <label class="switch switch-sm mb-0" title="Enable/Disable">
                    <input
                      type="checkbox"
                      id="question-active-{{question.id}}"
                      [disabled]="isToggling"
                      [(ngModel)]="question.isActive"
                      (change)="toggleActive(question)" />
                    <span class="slider round"></span>
                  </label>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      <grid-pager [actionName]="'/admin/questions'" [page]="page" [limit]="limit" [pageCount]="pageCount" [limits]="pageLimitOptions"></grid-pager>
    </fieldset>
  </div>
</div>
